module.exports = __webpack_public_path__ + "static/img/invalid_url.4fea59b9.png";